// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lF","a":"lG"};